/* esm.sh - @mediapipe/tasks-vision@0.10.35 */
export * from "/*@mediapipe/tasks-vision@0.10.35/esnext/tasks-vision.mjs";
